import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import { AuthService } from "../../../core/services/auth.service";
import { ResetPasswordRequest } from "../../../core/models/auth/auth.request";

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.scss",
})
export class ResetPasswordComponent implements OnInit {
  token: string | null = null;
  user: any = null;
  form: FormGroup;
  errorMessage: string | null = null;
  // Propiedades para controlar la visibilidad de las contraseñas
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    const StrongPasswordRegx: RegExp =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
    this.form = this.fb.group(
      {
        password: [
          "",
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(20),
            Validators.pattern(StrongPasswordRegx),
          ],
        ],
        confirmPassword: [
          "",
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(20),
            Validators.pattern(StrongPasswordRegx),
          ],
        ],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"];
      if (!this.token) {
        this.errorMessage = "Token inválido o expirado.";
        this.user = null;
        return;
      }
      try {
        this.user = jwtDecode(this.token);
      } catch (error) {
        console.error("Error al decodificar el token", error);
        this.errorMessage = "Token inválido o expirado.";
        this.user = null;
      }
    });
  }

  get password() {
    return this.form.get("password");
  }

  get confirmPassword() {
    return this.form.get("confirmPassword");
  }

  // Métodos para alternar la visibilidad de las contraseñas
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  resetPassword() {
    if (this.form?.valid) {
      this.errorMessage = null;
      let param: ResetPasswordRequest = {
        token: this.token ? this.token : "",
        newPassword: this.form?.value.password,
      };
      this.authService.resetPassword(param).subscribe({
        next: async (res: any) => {
          if (res.data === true) {
            console.log("res", res);
            Swal.fire({
              title: "Tu nueva contraseña ha sido guardada exitosamente",
              background: "#ffffff",
              showCloseButton: true,
              showCancelButton: true,
              cancelButtonText: "Cerrar",
              confirmButtonColor: "#ce0024",
              confirmButtonText: "Iniciar Sesión",
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(["/auth"]);
              }
              if (result.isDismissed) {
                this.router.navigate(["/auth"]);
              }
            });
          }
        },
        error: (err) => {
          console.log("err", err);
          this.errorMessage =
            err?.error?.message ||
            "Ocurrió un error al intentar guardar tu nueva contraseña.";
        },
      });
    }
  }

  checkPassword($event: any, elementId: string) {
    let pointer = document.getElementById(elementId);
    if (!pointer) return;

    let point = 0;
    let value = $event.target.value;
    let widthPower = ["10%", "25%", "50%", "75%", "100%"];
    let colorPower = ["#D73F40", "#DC6551", "#F2B84F", "#BDE952", "#3ba62f"];

    if (value.length >= 8) {
      let arrayTest = [/[0-9]/, /[a-z]/, /[A-Z]/, /(?=.*\W)/];
      arrayTest.forEach((item) => {
        if (item.test(value)) {
          point += 1;
        }
      });
    }
    pointer.style.width = widthPower[point];
    pointer.style.backgroundColor = colorPower[point];
  }

  passwordMatchValidator(form: FormGroup) {
    return form.get("password")?.value === form.get("confirmPassword")?.value
      ? null
      : { mismatch: true };
  }


}
